import cx from 'js/lib/helpers/cx'

import styles from './Wrapper.module.css'

const Wrapper = ({
    className,
    ...rest
}: React.ComponentPropsWithoutRef<'ul'>) => (
    <ul className={cx(styles.wrapper, className)} {...rest} />
)

export default Wrapper
